<div class="main-view" style="display: flex; flex-direction: column; height: 100%;">
  <app-main-menu title="Sheets"></app-main-menu>

  <div style="flex:1; height: calc(100vh - 60px)">
    <app-sheet-browser mode="edit"></app-sheet-browser>
  </div>
</div>
